/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import styled from 'styled-components';
import { ThemeInterface } from '../../common/theme/AppThemeInterface';
import appTheme from '../../common/theme/appTheme.json';
import { HubsMarkerIcon, HubsSvgProps } from './HubsMarkerIcon';

const theme: ThemeInterface = appTheme;
const PADDING = 5;
const EXTRA_PADDING = 5;
const MAX_PANEL_WIDTH = 300;

const HubNamePanelWrapper = styled.div`
  position: absolute;
  max-width: ${MAX_PANEL_WIDTH}px;
  height: ${theme.hubs.iconHeight}px;
  padding: ${PADDING}px;
  padding-right: ${PADDING + EXTRA_PADDING}px;

  background-color: ${theme.primaryBackgroundColor};
  color: ${theme.primaryTextColor};
  font-family: ${theme.appFontFamily};
  box-sizing: content-box;

  .icon {
    display: inline-block;
  }

  .text {
    display: inline-block;
    padding-left: ${EXTRA_PADDING}px;

    font-size: 14px;
    font-weight: 600;
    line-height: 32px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: ${MAX_PANEL_WIDTH - PADDING * 2 - EXTRA_PADDING * 2 - theme.hubs.iconWidth}px;
  }
`;

export interface HubNamePanelProps {
  hubName: string;
  iconProps: HubsSvgProps;
  left: number;
  top: number;
  mouseLeaveHandler: () => void;
}

const HubNamePanel = (props: HubNamePanelProps): React.ReactComponentElement<'div', {}> => {
  const { hubName, iconProps, left, top, mouseLeaveHandler } = props;

  const icon = HubsMarkerIcon(iconProps);
  const iconUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icon)}`;

  return (
    <HubNamePanelWrapper
      style={{
        left: left - PADDING,
        top: top - PADDING,
      }}
      onMouseLeave={mouseLeaveHandler}
    >
      <div className="icon">
        <img src={iconUrl} alt="" />
      </div>
      <div className="text">{hubName}</div>
    </HubNamePanelWrapper>
  );
};

export default HubNamePanel;
